(function () {
    let scheduled = false;

    function reposition() {
        scheduled = false;

        const details = document.querySelector('.main-product__details');
        if (!details) return;

        const gift = document.getElementById('sca-gift-thumbnail');
        if (!gift || !details.contains(gift)) return;

        const quantitySelector = details.querySelector('quantity-selector');
        if (!quantitySelector) return;

        const quantityBlock =
            quantitySelector.closest('.shopify-block') ||
            quantitySelector.parentElement;
        if (!quantityBlock || quantityBlock.parentElement !== details) return;

        if (quantityBlock.previousElementSibling === gift) return;

        details.insertBefore(gift, quantityBlock);
    }

    function schedule() {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(reposition);
    }

    schedule();
    new MutationObserver(schedule).observe(document.documentElement, {
        childList: true,
        subtree: true,
    });
    document.addEventListener('DOMContentLoaded', schedule);
    window.addEventListener('load', schedule);
})();
